export default __webpack_public_path__ + "static/media/landing_website_title.4cd0fa19.png";